import * as types from '../actions/actionTypes';
import { assign } from 'lodash';

const host = window.location.hostname
const local = (host.indexOf("local") > -1);
const staging = host.indexOf('staging') > -1;
const develop = (host.indexOf('develop.') > -1)
const ROOT_URL = (local || develop)
  ? 'https://myphoto-api-develop.appspot.com'
  : (staging)
    ? 'https://myphoto-api-staging.appspot.com'
    : 'https://mp-cloud-api.appspot.com'

const initialState = {
  results: [
    {
      id: 0,
      name: '',
    },
  ],
  optiongroup: {
    name: '',
  },
  meta: {
    count: 0,
    totalCount: 0,
    pageCount: 0,
    self: `${ROOT_URL}/optiongroups?page=1`,
    previous: null,
    next: null,
    first: null,
    last: null,
    page: 1,
    limit: 20,
  },
};

function optiongroups(state = initialState, action) {
  switch (action.type) {
    case types.OPTIONGROUPS_FETCH_SUCCESS:
      return assign({}, state, action.res);
    case types.OPTIONGROUPS_FETCH_ERROR:
    case types.OPTIONGROUP_FETCH_ERROR:
    case types.OPTIONGROUP_EDIT_ERROR:
    case types.OPTIONGROUP_SET_ERROR:
    case types.OPTIONGROUP_DISABLE_ERROR:
      return assign({}, state, {
        error: action.res,
      });
    case types.OPTIONGROUP_FETCH_SUCCESS:
    case types.OPTIONGROUP_EDIT_SUCCESS:
    case types.OPTIONGROUP_SET_SUCCESS:
      return assign({}, state, {
        optiongroup: action.res,
      });
    case types.OPTIONGROUP_DELETE_SUCCESS:
      return assign({}, state, {
        optiongroupsDelete: action.res.ok,
      });
    case types.OPTIONGROUPS_CLEAR_ERRORS:
    case types.OPTIONGROUP_CLEAR_ERRORS:
      return assign({}, state, {
        error: false,
      });
    default:
      return state;
  }
}

export default optiongroups;



// WEBPACK FOOTER //
// ./src/reducers/optiongroups.js